import { FilterType } from './FilterType';

export interface FilterInput {
  operator: FilterOperator;
  options: FilterOption[];
}

export interface FilterOption {
  field: string;
  values: string[];
  type: FilterType;
}

export enum FilterOperator {
  AND = 'AND',
  OR = 'OR'
}
